import * as z from "zod";
import { isAllDigits } from "../../shared/paymentValidation";
import ValidationMethods from "../utility/validationMethods";
import { uspsStateCodeSet } from "../utility/uspsStates";
export var isValidString = function (address) {
    for (var index = 0; index < address.length; index += 1) {
        var code = address.charCodeAt(index);
        // Reject non-ASCII
        if (code > 0x7f) {
            return false;
        }
        // Reject control characters
        if (code < 0x20 || code === 0x7f) {
            return false;
        }
        // 0–9
        if (code >= 48 && code <= 57) {
            continue;
        }
        // A–Z
        if (code >= 65 && code <= 90) {
            continue;
        }
        // a–z
        if (code >= 97 && code <= 122) {
            continue;
        }
        // Space
        if (code === 32) {
            continue;
        }
        // Allowed punctuation (comma intentionally excluded)
        switch (code) {
            case 35: // #
            case 39: // '
            case 45: // -
            case 46: // .
            case 47: // /
            case 92: // \
            case 40: // (
            case 41: // )
                continue;
        }
        // Anything else is illegal
        return false;
    }
    return true;
};
var containsLetter = function (value) {
    for (var index = 0; index < value.length; index += 1) {
        var code = value.charCodeAt(index);
        var isUppercaseLetter = code >= 65 && code <= 90;
        var isLowercaseLetter = code >= 97 && code <= 122;
        if (isUppercaseLetter || isLowercaseLetter) {
            return true;
        }
    }
    return false;
};
var containsNumber = function (value) {
    for (var index = 0; index < value.length; index += 1) {
        var code = value.charCodeAt(index);
        if (code >= 48 && code <= 57) {
            return true;
        }
    }
    return false;
};
var hasAtLeastOneLetterAndOneNumber = function (value) {
    var trimmedValue = value.trim();
    if (!trimmedValue) {
        return false;
    }
    return containsLetter(trimmedValue) && containsNumber(trimmedValue);
};
export var editAddressFlyOutSchema = z.object({
    address: z.string()
        .refine(isValidString, "Looks like the address field has a character we can’t process—try removing commas or special symbols and give it another shot.")
        .trim()
        .min(1, "Address is required.")
        .refine(hasAtLeastOneLetterAndOneNumber, "Addresses should contain both letters and numbers."),
    address2: z.string()
        .refine(function (value) { return ValidationMethods.isNotEmoji(value); }, "This field does not support emojis.")
        .optional(),
    city: z.string()
        .refine(isValidString, "Looks like the city name has a character we can’t process—try removing commas or special symbols and give it another shot.")
        .trim()
        .min(1, "City is required."),
    state: z.string()
        .refine(isValidString, "Looks like the state has a character we can’t process—try removing commas or special symbols and give it another shot.")
        .trim()
        .min(1, "State is required.")
        .length(2, "State must be exactly 2 letters.")
        .refine(isValidString, "State must only include letters.")
        .refine(function (state) { return uspsStateCodeSet.has(state.toUpperCase()); }, "State must be a valid US state code."),
    zip: z.string()
        .refine(isAllDigits, "Zip code must only contain numbers.")
        .trim()
        .length(5, "Zip code must be exactly 5 digits."),
});
